import { StreamChat } from "stream-chat";
import { Buyer } from "../../Models/Buyer";
import { ServerConfig } from "../NetworkClient/ServerConfig";

export class SessionManager {

    public static shared = new SessionManager();

    jwtTokenLocalStorageKey = "jwtToken"
    adminLocalStorageKey = "YdW3Rtra33W4"
    buyer: Buyer | undefined
    client: any

    // Auth Handling
    public isLoggedin(): boolean {
        let token = localStorage.getItem(this.jwtTokenLocalStorageKey)
        if(token) return true;
        return false
    }

    public getChatClient() {
        if(this.client) return this.client;
        this.client = StreamChat.getInstance(ServerConfig.shared.streamChatApiKey);
        return this.client;
    }

    public signOut() {
        this.buyer = undefined
        localStorage.clear();
        if(this.client && this.client.userID) {
            this.handleEmptyChatChannels(this.client);
            this.client.disconnectUser();
            this.client = undefined;
        }
    }

    public isSeller(): boolean {
        return this.buyer?.seller !== undefined
    }

    // Admin only APIs
    public getAdminAuthToken(): string | null {
      let token = localStorage.getItem(this.adminLocalStorageKey)
      return token;
    }

    public adminLogin(token: string) {
      localStorage.setItem(this.adminLocalStorageKey, token)
    }

    public isAdminLoggedin(): boolean {
      let isAdminLoggedin = localStorage.getItem(this.adminLocalStorageKey)
      if(isAdminLoggedin) return true;
      return false
    }

    public signOutAdmin() {
      localStorage.removeItem(this.adminLocalStorageKey);
    }



    // JWT Token Handling
    public fetchJWTToken(): string | null {
        let token = localStorage.getItem(this.jwtTokenLocalStorageKey)
        return token;
    }

    public saveJWTToken(token: string) {
        localStorage.setItem(this.jwtTokenLocalStorageKey, token);
    }

    public clearJWTToken() {
        localStorage.removeItem(this.jwtTokenLocalStorageKey);
    }

    public handleEmptyChatChannels = (client:any) => {
        const deleteChannels = async (emptyChannels:string[]) => {
          if(client) {
            await client.deleteChannels([...emptyChannels], {hard_delete: true});
          }
        }
      
        if(client) {
          const data = client.activeChannels;
          const dataVals = Object.values(data);
          const emptyChannels:string[] = []
          dataVals.forEach((channelItem:any, _) => {
            const msgLen = channelItem["state"]["messageSets"][0]["messages"].length;
            if(msgLen === 0 && channelItem["id"]) {
              emptyChannels.push(channelItem["cid"]);
            }
          })
          if(emptyChannels.length > 0) {
            deleteChannels(emptyChannels);
          }
        }
    }
}
